import React from 'react';
import { AccordionWrapper } from './Accordion.styled';
import AccordionItem from './AccordionItem';

type AccordionProps = {
  content: string;
  inverted: boolean;
  childrenContents: any[];
};

class Accordion extends React.PureComponent<AccordionProps> {
  renderAccordionItems() {
    const { childrenContents, inverted } = this.props;
    return childrenContents.map((content: any, index: number) => {
      const { id } = content;
      return (
        <AccordionItem
          key={id}
          inverted={inverted}
          content={content}
          renderActiveItem={index === 0}
        />
      );
    });
  }

  render() {
    return <AccordionWrapper>{this.renderAccordionItems()}</AccordionWrapper>;
  }
}

export default Accordion;
